module.exports = __webpack_public_path__ + "static/media/filled-star.fa8a69e6.svg";